import { render, staticRenderFns } from "./SponsoredRecommendation.vue?vue&type=template&id=73024791&scoped=true&"
import script from "./SponsoredRecommendation.vue?vue&type=script&lang=ts&"
export * from "./SponsoredRecommendation.vue?vue&type=script&lang=ts&"
import style0 from "./SponsoredRecommendation.vue?vue&type=style&index=0&id=73024791&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73024791",
  null
  
)

export default component.exports